module.exports = __webpack_public_path__ + "img/engine_icon.af77da30.png";